export default "__VITE_ASSET__DhPPFdGQ__"